<template>
    <div class="max pcenter color-light bg-pos-2 bg-size-cover auto-scroll" :style="`backgroundImage: url(${bg.bgImg})`">

        <!--header-->
        <sec-header-widget v-bind="header_data" />

        <!--什么是 1/2861？-->
        <section class="pad-h-2 mrg-v-2">
            <div class="rel container pad-h-1 pad-v-4 ">

                <!--遮罩-->
                <matteWidget v-bind="bg" />

                <h3 class="rel mrg-b-3 mrg-b-1-s">
                    <span class="fsize-1d5 fsize-d8-s">什么是 1/2861？</span>
                </h3>
                <article class="rel container fsize-1d3 pad-t-2 pjustify fsize-1d2-s pad-h-1-s" md>
                    <ul>
                        <li v-for="(info,i) of introduce" :key="i" class="line-b thick-1 line-neutral pad-b-d5 mrg-b-1d5">
                            <div class="fsize-1d2">
                                <b class="color-yellow mrg-r-1">·</b>{{info.main}}
                            </div>
                            <div class="fsize-d9 alpha-d6">{{info.sub}}</div>
                        </li>
                    </ul>
                </article>
            </div>
        </section>

        <!--1/2861为区域治理提供决策辅助数据服务-->
        <section class="container rel pad-v-4 pad-h-2 mrg-v-2 mrg-v-0-s pad-h-1-s">

            <!--遮罩-->
            <matteWidget v-bind="bg" />

            <h3 class="rel mrg-b-3 mrg-b-1-s"><span class="fsize-1d5 fsize-1-s">1/2861 为区域治理提供决策辅助数据服务</span></h3>
            <article class="rel container fsize-1d3 pad-t-2 pjustify fsize-1d2-s" md>
                <ul class="grid">
                    <li class="flex-5 col-6 col-12-s">
                        <ul class="grid w-30 h-30">
                            <li v-for="(text,i) of data_character.left" :key="i"
                                class="flex pad-d5 w-10 h-10">
                                <div :class="`grow-1 flex-5 alpha-d6 round-sm bg-color-${i===4? 'blue alpha-1': 'dgray'}`">{{text}}</div>
                            </li>
                        </ul>
                    </li>
                    <li class="col-6 col-12-s pad-h-1">
                        <list-widget :text-list="data_character.right" />
                    </li>
                </ul>
            </article>
        </section>

        <!--1/2861 示例-->
        <section class="container rel pad-v-4 mrg-v-2 pad-h-1">

            <!--遮罩-->
            <matteWidget />

            <h3 class="rel mrg-b-3 mrg-b-2-s">
                <span class="fsize-1d5 fsize-1-s">1/2861 示例</span>
            </h3>
            <div class="rel fsize-1d2 round-sm bg-color-dgray">
                <slider-widget v-bind="slider_data">
                    <article v-for="(page,i) of slider_data.pages" :key="i" :slot="page.id"
                         class="pad-h-1 pad-t-2 pad-b-2">
                        <div class="pcenter fsize-1d2 mrg-b-2">{{page.desc}}</div>
                        <img :src="page.src" class="round-md" />
                    </article>
                </slider-widget>
            </div>
        </section>

        <!--本地区数据指标报告一键生成-->
        <section class="container rel pad-v-4 mrg-v-2">

            <!--遮罩-->
            <matteWidget />

            <h3 class="rel mrg-b-3 mrg-b-1-s">
                <span class="fsize-1d5 fsize-1-s">本地区数据指标报告一键生成</span>
            </h3>
            <ul class="grid">
                <li class="col-4 col-12-s pad-h-2 pad-v-d5" v-for="(report,i) of data_report" :key="i">
                    <img :src="report" class="round-md" />
                </li>
            </ul>
        </section>

        <!--daas 简介-->
        <sec-about-daas-widget :matte-data="bg" />

        <!--footer-->
        <section>
            <article class="pad-b-10 pad-h-2 pad-t-5">
                <p class="fsize-1d7 fsize-1d5-s">
                    <img :src="require('@/assets/img/logo/2861_logo.png')" class="w-15" /><br>助力区域治理现代化
                </p>
            </article>
        </section>
    </div>
</template>

<script>
    import TabWidget from "@/components/BTXUI/tab/tab-widget"
    import SliderWidget from "@/components/BTXUI/slider/slider-widget"
    import ListWidget from "@/components/list-widget"
    import matteWidget from "@/components/matte-widget"
    import SecHeaderWidget from "@/components/sec-header-widget"
    import SecDataPackageWidget from "@/components/sec-data-package-widget"
    import SecDataApplyWidget from "@/components/sec-data-apply-widget"
    import SecAboutDaasWidget from "@/components/sec-about-daas-widget"

    const name = "visual";

    export default {
        name,
        components: {
            TabWidget,
            SliderWidget,
            ListWidget,
            matteWidget,
            SecHeaderWidget,
            SecDataPackageWidget,
            SecDataApplyWidget,
            SecAboutDaasWidget
        },
        data(){
            const bg = {
                bgImg: require(`@/assets/img/daas_case/${name}_bg.jpg`),
                bgColor: "dgray"
            }

            return {

                //背景
                bg,

                //头部信息
                header_data: {
                    packageId: name,
                    mainNavData: {
                        logo: require('@/assets/img/logo/logo.png'),
                        navs: [
                            {
                                text: "首页",
                                link: "/"
                            }
                        ]
                    }
                },

                //什么是 1/2861？
                introduce: [
                    {
                        main: "基于清华DaaS数据库的可视化智能决策辅助系统",
                        sub: "数据库数据7*24小时实时收集、计算、产生指标，覆盖全国所有省市区县。"
                    },
                    {
                        main: "国家顶级智库采用基础数据构建指标体系",
                        sub: "指标体系用于提供地方高质量发展、城市体检、经济发展和民众口碑等相关报告的数据支撑，递交发改委、住建部、中组部、中央党校等部委。"
                    },
                    {
                        main: "200+指标，2000+页数据可视化展示，每月更新",
                        sub: "可视化包含：指标在全国/全省/全市范围排名和分布，指标历史变化趋势展示，多指标关联对比分析；每月区县指标报告一键生成。"
                    }
                ],

                //1/2861 为区域治理提供决策辅助数据服务
                data_character: {
                    left: [
                        "宣传部",
                        "政研室",
                        "国土资源局",
                        "商务局",
                        "县委办公室",
                        "交通局",
                        "环保局",
                        "规划局",
                        "..."
                    ],
                    right: [
                        "国家顶级智库报告采用的区域基础指标数据分析和展示",
                        "区域发展数据监测：人口、产业、民生、稳定、环境...",
                        "区域经济发展规划中的宏观数据获取与分析",
                        "区域资源利用、环境保护、区域稳定相关事件预警",
                        "区域招商引资的区域画像和优势挖掘",
                        "区域基础建设与政府服务能力展示",
                        "区域常住人口结构、特点与人员流动趋势分析",
                        "区域民众热议话题跟踪和分析",
                        "区域指标月报一键生成",
                        "......"
                    ]
                },

                //1/2861 示例
                slider_data: {
                    pages: [
                        {
                            id: "a",
                            desc: "指标强弱分布速览",
                            src: require("@/assets/img/daas_case/f10.png")
                        },
                        {
                            id: "b",
                            desc: "宏观指标时间趋势展示",
                            src: require("@/assets/img/daas_case/f11.png")
                        },
                        {
                            id: "c",
                            desc: "同区域关联指标分析",
                            src: require("@/assets/img/daas_case/f12.png")
                        }
                    ],
                    view: {
                        height: "auto"
                    },
                    showDot: {
                        bottom: "15px",
                        color: "#fff",
                        act_color: "#ffcc00"
                    },
                    showFlipBtn: true,
                    autoPlayDuration: 4000,
                    loop: true
                },

                //本地区数据指标报告一键生成
                data_report: [
                    require("@/assets/img/daas_case/f13.png"),
                    require("@/assets/img/daas_case/f14.png"),
                    require("@/assets/img/daas_case/f15.png")
                ]
            }
        },
        mounted(){
            document.title = "1/2861 区县社会感知大数据决策辅助系统"
        }
    }
</script>


// WEBPACK FOOTER //
// src/router/visual.vue